import React from 'react';

const StatsCard = ({ title, value, subtitle, icon, color = 'blue' }) => {
    const colorClasses = {
        blue: {
            bg: 'from-blue-500 to-blue-600',
            light: 'bg-blue-50',
            border: 'border-blue-200',
            text: 'text-blue-600'
        },
        green: {
            bg: 'from-green-500 to-green-600',
            light: 'bg-green-50',
            border: 'border-green-200',
            text: 'text-green-600'
        },
        orange: {
            bg: 'from-orange-500 to-orange-600',
            light: 'bg-orange-50',
            border: 'border-orange-200',
            text: 'text-orange-600'
        },
        purple: {
            bg: 'from-purple-500 to-purple-600',
            light: 'bg-purple-50',
            border: 'border-purple-200',
            text: 'text-purple-600'
        },
        red: {
            bg: 'from-red-500 to-red-600',
            light: 'bg-red-50',
            border: 'border-red-200',
            text: 'text-red-600'
        },
    };

    const colors = colorClasses[color] || colorClasses.blue;

    return (
        <div className={`bg-white rounded-xl shadow-sm p-6 hover:shadow-lg transition-all duration-300 border ${colors.border} h-full`}>
            <div className="flex items-start justify-between">
                <div className="flex-1">
                    <p className="text-sm font-medium text-gray-600 uppercase tracking-wide mb-2">{title}</p>
                    <p className={`text-4xl font-bold ${colors.text} mb-1`}>{value}</p>
                    {subtitle && (
                        <p className="text-sm text-gray-500 mt-2">{subtitle}</p>
                    )}
                </div>
                {icon && (
                    <div className={`bg-gradient-to-br ${colors.bg} p-4 rounded-xl text-white shadow-md`}>
                        {icon}
                    </div>
                )}
            </div>
        </div>
    );
};

export default StatsCard;
